import React, { FC, useState, useEffect } from 'react';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { HomeExpiredMain } from './HomeExpiredMain';
import { useUser } from '../user/useUser';

export const HomeExpired: FC = () => {
  const [hasCalled, setHasCalled] = useState(false);
  const {
    currentUser: { expirationDate, origExp, isIcp },
  } = useUser();
  const isContacted = expirationDate !== origExp;

  useEffect(() => {
    doctrineAnalytics('Account TrialExpiredAppeared');
  }, []);

  const onCall = () => {
    setHasCalled(true);
    // Salesforce event: do not modify without consultation
    doctrineAnalytics('Home EndTrialCallNow', {
      is_icp: isIcp,
      is_icp_and_verified: isIcp && isContacted,
    });
  };

  const onContact = () => {
    window.Intercom('show');
  };

  return (
    <HomeExpiredMain
      isIcp={isIcp}
      isContacted={isContacted}
      hasCalled={hasCalled}
      onCall={onCall}
      onContact={onContact}
    />
  );
};
